import React from 'react';
import styled from 'styled-components';
import RadioBox from 'src/components/atoms/form/RadioBox';
import InputLabelHolder from 'src/components/molecules/form/InputLabelHolder';

type Props = {
  name: string;
  id: string;
  value: string;
  onChange: (value: string) => void;
  onValue: string;
  offValue: string;
  isRequired: boolean;
  labelName: string;
};

export const RadioInputBlock = ({ ...props }: Props) => {
  return (
    <Container>
      <InputLabelHolder labelName={props.labelName} isRequired={props.isRequired} />
      <div className="input_block">
        <RadioBox
          name={props.name}
          id={props.id}
          value={props.onValue}
          isChecked={props.value === props.onValue}
          onChange={props.onChange}
        />

        <RadioBox
          name={props.name}
          id={props.id}
          value={props.offValue}
          isChecked={props.value === props.offValue}
          onChange={props.onChange}
        />
      </div>
    </Container>
  );
};

const Container = styled.div`
  box-sizing: border-box;
  > .input_block {
    display: flex;
    justify-content: space-around;
    > label {
      width: 50%;
    }
  }
`;
export default RadioInputBlock;
